import Lenis from "lenis";
import { ScrollTrigger } from "gsap/ScrollTrigger";

let lenis = null;
let rafId = null;

export const initLenis = () => {
    if (lenis) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenis.on("scroll", ScrollTrigger.update);
    const raf = (time) => {
        lenis.raf(time);
        rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
};

export const destroyLenis = () => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = null;
    if (lenis) lenis.destroy();
    lenis = null;
};

export const scrollToId = (id) => {
    const el = document.querySelector(id);
    if (!el) return;
    if (lenis) lenis.scrollTo(el, { offset: -72, duration: 1.5 });
    else el.scrollIntoView({ behavior: "smooth" });
};
